import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import _ from "underscore";
import AutoQuery from "servicestack/auto-query/auto-query";

export default class SwatchViewController extends BasicAutoQueryController {
  getQueries() {
    const $ctrl = this;
    return {
      query: {
        url: "QuerySwatches.json?op=SwatchViewController",
        criteria: {
          id: $ctrl.swatchId,
        },
        autoLoad: true,
        onLoaded(args) {
          $ctrl.swatch = args.first;
          if ($ctrl.swatch.meta.SalesAids) {
            var aides = _.indexBy(
              JSON.parse($ctrl.swatch.meta.SalesAids),
              "ProductId"
            );
            var productIds = Object.keys(aides).join(",");
            $ctrl.salesAidesQuery = new AutoQuery({
              url:
                "QueryProducts.json?op=SwatchViewController&IdIn=" + productIds,
              autoLoad: true,
              scrub: (res) => {
                res.data.results.forEach(function (obj) {
                  obj.salesAideDescription = aides[obj.id].SalesAidDescription;
                });
              },
            });
          }
        },
      },
    };
  }

  $onInit() {
    let $ctrl = this;
      super.$onInit && super.$onInit();
    if (!$ctrl.size) $ctrl.size = "large";
    if (!$ctrl.zoomSize) $ctrl.zoomSize = "large";
    // BEGIN: MAGIC ZOOM PLUS SETTINGS
    if (!$ctrl.zoomMode) $ctrl.zoomMode = "magnifier";
    if (!$ctrl.zoomOn) $ctrl.zoomOn = "click";
    if (!$ctrl.expand) $ctrl.expand = "off";
    if (!$ctrl.hint) $ctrl.hint = "once";
    if (!$ctrl.textClickZoomHint) $ctrl.textClickZoomHint = "Click to zoom";
  }
  getImageUrl(id, size) {
    return this.$appConfig.productImage(id, size);
  }
}
